import * as React from 'react'
import { Icon, IconSizeName } from '$views/components/Icon'
import { Link as RouterLink } from 'react-router-dom'
import styled from 'styled-components'
import { FontWeight } from '$utils/theme'

interface Props extends React.AnchorHTMLAttributes<any> {
  className?: string
  title?: string
  icon?: string
  size?: IconSizeName
  onClick?: any
  target?: string
  id?: string
  noneTextDecoration?: boolean
}

const StyledIcon = styled(Icon)`
  path {
    fill: ${p => p.theme.colors.blue};
  }
`

const LinkRaw: React.SFC<Props> = props => {
  const isInternal = to => {
    return to.indexOf('://') === -1 && to.indexOf('mailto:') === -1 && to.indexOf('tel:') === -1
  }

  const externalLink = (
    <>
      {props.icon && <StyledIcon content={props.icon} size="m" />}
      <a
        href={props.href}
        className={props.className}
        title={props.title}
        target={props.target}
        color={props.color}
        id={props.id}
      >
        {props.children}
      </a>
    </>
  )

  const internalLink = (
    <>
      {props.icon && <StyledIcon content={props.icon} size="m" />}
      <RouterLink className={props.className} to={props.href} target={props.target} color={props.color} id={props.id}>
        {props.children}
      </RouterLink>
    </>
  )

  const clickLink = (
    <>
      {props.icon && <StyledIcon content={props.icon} size="m" />}
      <a onClick={props.onClick} className={props.className} title={props.title} color={props.color} id={props.id}>
        {props.children}
      </a>
    </>
  )

  return props.onClick ? clickLink : isInternal(props.href) ? internalLink : externalLink
}

export const Link = styled(LinkRaw)`
  color: ${p => (p.color ? p.theme.colors[p.color] : p.theme.colors.darkGrey)} !important;
  font-weight: ${FontWeight.medium};
  text-decoration: underline !important;
  ${p =>
    p.noneTextDecoration &&
    `
    text-decoration: none !important;
  `}
  cursor: pointer;

  &:hover {
    color: ${p => p.theme.colors.black} !important;
  }
`



// WEBPACK FOOTER //
// ./src/views/components/Link/Link.tsx